<template>
  <div class="margin-bottom-m margin-top-s">
    <div class="error-color large">Sorry, this item is currently unavailable.</div>

    <div v-if="similarItemsUrl" :class="marginTopClass">
      <a :href="similarItemsUrl" class="button emphasis expanded">Shop Similar Items</a>
    </div>

    <div v-if="brandUrl" class="margin-top-xs">
      <a :href="brandUrl" class="button secondary expanded" v-html="`Shop All ${brandDisplayName}`"></a>
    </div>

    <div v-if="showCallCenterBanner" class="margin-top-s" data-test-id="call-center-message-unavailable" v-html="callCenterMessage"></div>

    <ProsZoneAVertical v-if="isMcom && !isMobile" data-testid="pros-section" class="cell large-12 margin-top-xl" />
  </div>
</template>

<script setup lang="ts">
import { defineAsyncComponent, computed } from 'vue';
import { useBrand } from '~/composables/useBrand';
import { useDeviceType } from '~/composables/utils/useDeviceType';
import { useCommonProductGetters } from '~/composables/useCommonProductGetters';
import useUnavailableProduct from '~/composables/useUnavailableProduct';
import { useCallCenter } from '~/composables/useCallCenter';

const ProsZoneAVertical = defineAsyncComponent(() => import('~/modules/pros/ProsZoneAVertical.vue'));

const { similarItemsUrl } = useUnavailableProduct();
const { isMobile } = useDeviceType();

const { brandDisplayName, brandUrl } = useCommonProductGetters();

const { showCallCenterBanner, callCenterMessage } = useCallCenter(false);

const { isMcom } = useBrand();
const marginTopClass = computed(() => (isMcom ? 'margin-top-m' : 'margin-top-s'));
</script>

<style lang="scss" scoped>
@import '~settingSCSS';

.unavailable-message {
  font-weight: bold;
  font-size: rem-calc(16);
  color: $black;
}
</style>
